import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CheckoutComponent } from "../shop-components/checkout/checkout.component";
import { HomePageComponent } from "../shop-components/home-page/home-page.component";
import { OrderConfirmComponent } from "../shop-components/order-confirm/order-confirm.component";
import { PaymentCancelComponent } from "../shop-components/payment-cancel/payment-cancel.component";
import { PaymentStatusComponent } from "../shop-components/payment-status/payment-status.component";
import { ProductPageComponent } from "../shop-components/product-page/product-page.component";
import { ShopLayoutComponent } from "./shop-layout.component";
import { RegisterComponent } from "../shop-components/customer-register/register/register.component";
import { ConfirmAccountComponent } from "../shop-components/confirm-account/confirm-account/confirm-account.component";
import { ResendConformationComponent } from "../shop-components/customer-register/resend-conformation/resend-conformation.component";
import { CustomerDownloadInvoiceComponent } from "../shop-components/customer-download-invoice/customer-download-invoice.component";
import { RequestQuoteComponent } from "../shop-components/request-quote/request-quote.component";
import { ExcludedStatecodeComponent } from "../../layoutModule/components/admin/excluded-statecode/excluded-statecode.component";
import { ReviewComponent } from "../shop-components/review-management/review.component";
import { CustomerReviewFormComponent } from "../shop-components/customer-review-form/customer-review-form.component";

import {  ProductComponent } from "../shop-components/product-type/product.component";

const routes: Routes = [
    {
        path: '',
        component: ShopLayoutComponent,
        children: [
            { path: 'home-page', component: HomePageComponent },
            { path: 'product-page/:productId', component: ProductPageComponent },
            { path: 'order-confirm/:productId', component: OrderConfirmComponent },
            { path: 'order-confirm/:productId/:warrantyId/:warrantyPriceId/:isApplicationPriceSelected', component: OrderConfirmComponent },
            { path: 'payment-status', component: PaymentStatusComponent },
            { path: 'payment-cancel', component: PaymentCancelComponent },
            { path: 'register', component: RegisterComponent },
            { path: 'confirm-account/:token', component: ConfirmAccountComponent },
            { path: 'resend-conformation', component: ResendConformationComponent },
            { path: 'customer-download-invoice/:id', component: CustomerDownloadInvoiceComponent },
            { path: 'request-quote/:productId', component: RequestQuoteComponent },
            { path: 'excluded-statecode', component: ExcludedStatecodeComponent },
            { path: 'review', component: ReviewComponent },
            { path: 'customer-review-form', component: CustomerReviewFormComponent },
            { path: 'product/:id', component:  ProductComponent }

        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ShopLayoutRoutingModule { }